import React from "react";
import PropTypes from "prop-types";
import styles from "./EmergencyList.module.css";
import { v4 } from "uuid";

import DocumentItem from "../../Shared/DocumentItem";
import PdfIcon from "../../assets/file-light.svg";

/**
 * Interactive component.
 * Displays the emergency information under the emergency tab on the EventDetails page.
 */
export function EmergencyList({ onUpload, emergencyItems }) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p>Venue Security and Emergency Documents</p>
        <button className={styles["upload-button"]} onClick={onUpload}>
          Upload
        </button>
      </div>
      <ul className={styles["document-list"]}>
        {emergencyItems.map((item) => (
          <li key={v4()}>
            <DocumentItem {...item} icon={PdfIcon} />
          </li>
        ))}
      </ul>
    </div>
  );
}

EmergencyList.propTypes = {
  /**
   * Function called when upload is clicked.
   */
  onUpload: PropTypes.func,
  /**
   * Array of the emergency items.
   */
  emergencyItems: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Title of document.
       */
      description: PropTypes.string,
      /**
       * Function that opens PDF link.
       */
      onClick: PropTypes.func,
    })
  ),
};

EmergencyList.defaultProps = {
  emergencyItems: [],
};
